module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC/SURBVHgB7ZWBDYMgEEWPTtAR6AYdod2gI7hZR8ER3EA30A1+j5Q0hAhyFDUmvuQCAXJ8jjsgOjk0AB5shm3EF9vXVBN2+MI8dtM71YKd9YhjqAZWMZa5SnxeIuMTycUZJ6DJ3kgpNXAzUJyO14jFzOIybjEZvJOENL6/WOjsqVpubmytG5pc/8lzHe1F0R1tAivSibj7vPHPK4F0oYaUFS7imZZC5/gO76ikNkQvxA9h6HoqBXnJMGKNL+NkVz4LZcMtrg8d6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_recruitment.png
// module id = fGj8
// module chunks = 1